import { useMemo } from 'react';
import type { GridSize } from '@mui/system';

import type {
  DashboardWidgetConfig,
  DashboardWidgetSize,
} from 'src/types/dashboard';
import { getWidgetDefaultSize } from 'src/components/dashboard/DashboardPage/components/WidgetWrapper/widgetMaps';

const useGridSize = (config: DashboardWidgetConfig) => {
  const { widget_type: widgetType, size: widgetSize } = config;

  return useMemo(() => {
    const sizeMap: { [size in DashboardWidgetSize]: GridSize } = {
      XL: 12,
      L: 8,
      M: 6,
      S: 4,
      XS: 3,
      XXS: 2,
    };
    let size;
    if (widgetSize === 'auto') {
      size = getWidgetDefaultSize(widgetType);
    } else {
      size = widgetSize;
    }
    return sizeMap[size as DashboardWidgetSize] || sizeMap.XL;
  }, [widgetType, widgetSize]);
};

export default useGridSize;
